module.exports = __webpack_public_path__ + "img/logo-1.6c091a7a.svg";